import React from 'react'
import './careers.css'

function CareersBody() {
  return (
    <section className='openPosition_body'>
        <div className='container careersBody_main'>

             <div className='careersBody_wrapper'>

<p className='careersBody_main_title'>HW/SW design expert with strong experience in Xilinx Vitis Environment</p>
    
<p className='careersBody_title'>About the job</p>

<p className='careersBody_content'>Web3 promises a decentralized future. To make it a reality, efficiency gains of several orders of magnitude have to be achieved. We at PONOS Technology are taking on these tremendous challenges by applying our cutting edge expertise and engineering skills to the latest research results.</p>

<p className='careersBody_title'>At Ponos Technology you will:</p>

<ul className='careersBody_list'>
  <li>Take part of a small, but elite team of engineers as a consultant, part-time or eventually full time employee</li>
  <li>Apply your knowledge to achieve efficiency gains of an order of magnitude by accelerating software critical modules in FPGA and removing bottlenecks</li>
  <li>Work on a cutting edge hardware</li>
  <li>Receive a competitive package</li>
  <li>Work remotely or in our offices in Zug/ Belgrade</li>
</ul>

<p className='careersBody_content'>If you know how to smartly utilize Xilinx tools to accelerate compute-heavy algorithms, we can start collaborating.</p>

<p className='careersBody_title'>Responsibilities</p>

<ul className='careersBody_list'>
  <li>Utilize Xilinx Vitis to develop host application and customize firmware</li>
  <li>Employ RTL kernel flow for HW integration on Alveo boards</li>
  <li>Develop efficient interface/communication with kernel using OpenCL and/or Xilinx XRT API</li>
  <li>Algorithm understanding in C/C++, Python or Rust and ability to translate them to efficient RTL code</li>
  <li>Simulation, synthesis, implementation and debugging on FPGAs (Xilinx Vitis toolset)</li>
  
</ul>

<p className='careersBody_title'>Qualifications</p>

<ul className='careersBody_list'>
  <li>You have applied your deep knowledge of the above and implemented relevant projects on Xilinx FPGAs boards using the proper toolset as a proof of concept, prototype, or product</li>
  <li>You have a BSc/MSc/PhD in computer science/engineering, electrical engineering or similar discipline</li>
  <li>Solid experience with newer Xilinx evaluation/prototyping boards (Series 7, UltraScale(+)) and development environment</li>
 
</ul>

 </div>

 <a 
// info@ponos.technology
href="mailto:info@ponos.technology?subject=Careers%20at%20Ponos%20Technology%20-%20HW/SW%20design%20expert%20with%20strong%20experience%20in%20Xilinx%20Vitis%20Environment" 
 className='careersBody_btn no-wrap'>
                          <span>Apply Now</span>
                         </a>

       

        </div>
    </section>
  )
}

export default CareersBody
